export interface IHost {
  name: string;
  hostName: string;
  url: string;
  apiUrl: string;
  favicon: string;
  logoDarkBg: string;
  logoLightBg: string;
}

const origin = typeof window !== 'undefined' ? window.location.origin : '';
const host = origin.split('://')[1] || '';

const DefaultHostData: IHost = {
  name: 'Ketto',
  hostName: host || 'www.ketto.org',
  url: origin || 'https://www.ketto.org',
  apiUrl: (origin || 'https://www.ketto.org') + '/api/',
  favicon: '/assets/favicons/ketto.ico',
  logoDarkBg: '/assets/images/logo-light-bg.svg',
  logoLightBg: '/assets/images/logo-light-bg.svg',
};

const DevDefaultHostData: IHost = {
  ...DefaultHostData,
  apiUrl: (origin || 'https://devapis.ketto.org') + '/api/',
};

export const HOST_LIST: { [key: string]: IHost } = {
  'ketto.org': DefaultHostData,
  'dev1.ketto.org': {
    ...DevDefaultHostData,
    hostName: host || 'dev1.ketto.org',
    url: origin || 'http://dev1.ketto.org',
    apiUrl: (origin || 'https://dev1.ketto.org') + '/api/',
  },
  'dev2.ketto.org': {
    ...DevDefaultHostData,
    hostName: host || 'dev2.ketto.org',
    url: origin || 'http://dev2.ketto.org',
    apiUrl: (origin || 'https://dev2.ketto.org') + '/api/',
  },
  'dev4.ketto.org': {
    ...DevDefaultHostData,
    hostName: host || 'dev4.ketto.org',
    url: origin || 'http://dev4.ketto.org',
    apiUrl: (origin || 'https://dev4.ketto.org') + '/api/',
  },
  'dev5.ketto.org': {
    ...DevDefaultHostData,
    hostName: host || 'dev5.ketto.org',
    url: origin || 'http://dev5.ketto.org',
    apiUrl: (origin || 'https://dev5.ketto.org') + '/api/',
  },
  'dev6.ketto.org': {
    ...DevDefaultHostData,
    hostName: host || 'dev6.ketto.org',
    url: origin || 'http://dev6.ketto.org',
    apiUrl: (origin || 'https://dev6.ketto.org') + '/api/',
  },
  'localhost': {
    ...DevDefaultHostData,
    hostName: host || 'localhost:4000',
    url: origin || 'http://localhost:4000',
    apiUrl: 'https://devapis.ketto.org/api/'
  }
};